define('shared/remote/efid/create',[
    '../ajax',
    'shared/lib/RSVP',
    './const',
    './util'
], function (
    ajax,
    RSVP,
    constants,
    util
) {

    function create(options) {
        return RSVP.resolve()
            .then(function () {
                var postingData;

                return RSVP.resolve()
                    .then(function(){
                        return util.getContinueURI();
                    })
                    .then(function(uriContinue){
                        postingData = {
                            given_name: options.name.given,
                            family_name: options.name.family,
                            email: options.email,
                            password: options.password,
                            country: options.market,
                            language: options.language
                        };

                        postingData.continue_uri = uriContinue.toString();
                    })
                    .then(function(){
                        return ajax({
                                method: 'post',
                                url: '/1/api/commerce-gateway/efid/user', 
                                data: postingData
                            })
                            .then(null, function (xhr) {
                                if (xhr && xhr.status === 400)  {
                                    var errorMessages = [];
                                    var json = xhr.responseJSON;
                                    var errType = 'generic';

                                    if (!json || !json.fields) {
                                        return RSVP.reject('EFID creation failed, server didn\'t return response correctly');
                                    }
                                    
                                    for(var l = json.fields.length; l--;) {
                                        if (
                                            json.fields[l].name === 'email' && 
                                            json.fields[l].text.toLowerCase() === 'identifier exists'
                                        ) {
                                            errType = util.REGISTERED;
                                        }
                                        var msg = json.fields[l].name + ' ' + json.fields[l].text;
                                        msg = msg.toLowerCase();
                                        msg = msg.charAt(0).toUpperCase() + msg.substr(1);
                                        errorMessages.push(msg);
                                    }

                                    var error = new Error(errorMessages.join(','));
                                    error.fields = json.fields;
                                    error.type = errType;
                                    error.origin = 'efid';

                                    return RSVP.reject(error);
                                }
                                else {
                                    return RSVP.reject('EFID creation failed');
                                }
                            });
                    })
                    .then(function(data){
                        return util.waitForAccessToken(data.continue_uri)
                            .then(function(){
                                return data; 
                            });
                    });
            });
    }   

    return create;
});
